import { render, staticRenderFns } from "./TemplatedFields.vue?vue&type=template&id=57a2767d&scoped=true"
import script from "./TemplatedFields.vue?vue&type=script&lang=js"
export * from "./TemplatedFields.vue?vue&type=script&lang=js"
import style0 from "./TemplatedFields.vue?vue&type=style&index=0&id=57a2767d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a2767d",
  null
  
)

export default component.exports